 
let env = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  REACT_APP_ENABLE_MOCK_API: process.env.REACT_APP_ENABLE_MOCK_API == "true",
  REACT_APP_ENABLE_APPLICATION_INSIGHTS:
    process.env.REACT_APP_ENABLE_APPLICATION_INSIGHTS == "true",
  REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY:
    process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
  FAST_REFRESH: process.env.FAST_REFRESH == "true",
  REACT_APP_PING_INTERVAL_SECONDS: process.env.REACT_APP_PING_INTERVAL_SECONDS,
  REACT_APP_AG_GRID_LICENSE_KEY: process.env.REACT_APP_AG_GRID_LICENSE_KEY,
  REACT_APP_AHA_API_KEY: process.env.REACT_APP_AHA_API_KEY,
  REACT_APP_AHA_PROJECT_CODE: process.env.REACT_APP_AHA_PROJECT_CODE,
  REACT_APP_FILE_UPLOAD_ORIGIN_ID: process.env.REACT_APP_FILE_UPLOAD_ORIGIN_ID,
  REACT_APP_FORCE_TENANT: process.env.REACT_APP_FORCE_TENANT === "true",
  REACT_APP_SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
  REACT_APP_DEVELOPMENT: process.env.REACT_APP_DEVELOPMENT == "true",
  REACT_APP_IS_LOCAL: process.env.REACT_APP_IS_LOCAL == "true",
  REACT_APP_ENABLE_PAGE_LOADER: process.env.REACT_APP_ENABLE_PAGE_LOADER == "true",
  REACT_APP_UPDATES_DEFAULT_INTERVAL_SECONDS: process.env.REACT_APP_UPDATES_DEFAULT_INTERVAL_SECONDS,
  REACT_APP_UPDATES_ON_DEMAND_INTERVAL_SECONDS: process.env.REACT_APP_UPDATES_ON_DEMAND_INTERVAL_SECONDS,
  REACT_APP_UPDATES_ON_DEMAND_DURATION_SECONDS: process.env.REACT_APP_UPDATES_ON_DEMAND_DURATION_SECONDS,
  REACT_APP_DOCEBO_INSTANCE_DOMAIN: process.env.REACT_APP_DOCEBO_INSTANCE_DOMAIN ?? "eyskillsfoundrysandbox.docebosaas.com",
  REACT_APP_AUTH_INSTANCE: process.env.REACT_APP_AUTH_INSTANCE ?? "Default",
  REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
  REACT_APP_AUTH0_SCOPE: process.env.REACT_APP_AUTH0_SCOPE,
};

if (
  process.env.NODE_ENV.toUpperCase() == "PRODUCTION" &&
  window.location.hostname.toUpperCase() == "LOCALHOST" &&
  process.env.REACT_APP_API_ENDPOINT_DOCKER.length > 0
) {
  env.REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT_DOCKER;
  env.REACT_APP_AUTH_REDIRECT_URL = process.env.REACT_APP_AUTH_REDIRECT_URL_DOCKER;
}

export default env;